<template>
  <div class="creation-demand-step-dates">
    <!-- Template for CDI (one date selected) -->
    <template v-if="dateType === CREATION_DATES_TYPES.SINGLE">
      <h2 class="step-title">
        {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@SINGLE_DATE_TITLE")) }}
      </h2>
      <DateSingle :date="start" @select-asap="selectAsap" @select-date="openCalendar('single')" />
    </template>
    <!-- Template for SEASON (startdate and enddate selected) -->
    <template v-if="dateType === CREATION_DATES_TYPES.MULTIPLE">
      <h2 class="step-title">
        {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@MULTIPLE_DATES_TITLE")) }}
      </h2>
      <DatesMultiple :dates="{ start, end }" @select-dates="openCalendar('range')" />
    </template>
    <!-- Template for AE (startdate and enddate selected) -->
    <template v-if="dateType === CREATION_DATES_TYPES.BOTH">
      <h2 class="step-title">
        {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@SINGLE_OR_MULTIPLE_DATES_TITLE")) }}
      </h2>
      <DatesBoth :date="{ start, end }" @select-single="openCalendar('single')" @select-multiple="openCalendar('range')" />
    </template>
    <transition appear enter-active-class="animated fadeIn slower delay-1s" leave-active-class="animated fadeOut">
      <section class="q-footer q-layout__section--marginal fixed-bottom">
        <div>
          <QBtn
            v-if="start"
            color="secondary"
            class="full-width btn-navigation"
            :label="$t('ETAB.BUTTONS.@NEXT')"
            no-caps
            :loading="loading"
            @click="save"
          />
        </div>
      </section>
    </transition>

    <DatepickerModal v-model:opened="modalOpened" :dates="{ start, end }" :min-date="minDate" :mode="calendarMode" @set-date="setDate" />
  </div>
</template>

<script>
  import { DatesHelpers } from "@core/helpers";
  import { CreationStepDatesModel, ICreationStepDates, ICreationStepPlanning } from "@core/models";
  import { CREATION_DATES_TYPES } from "@core/constants";
  import DateSingle from "@etab/components/creation/DateSingle.component.vue";
  import DatesMultiple from "@etab/components/creation/DatesMultiple.component.vue";
  import DatesBoth from "@etab/components/creation/DatesBoth.component.vue";
  import DatepickerModal from "@etab/components/creation/Datepicker.modal.vue";

  export default {
    components: {
      DateSingle,
      DatesMultiple,
      DatepickerModal,
      DatesBoth,
    },
    props: {
      transition: {
        type: Boolean,
        required: false,
      },
      stepAssets: {
        type: Object,
        required: true,
      },
      stepData: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["saveStep"],
    data() {
      return {
        modalOpened: false,
        calendarMode: "single",
        start: undefined,
        end: undefined,
        minDate: new Date(), // cannot select before today
      };
    },
    computed: {
      stepDataModel() {
        return new CreationStepDatesModel(this.stepData[ICreationStepPlanning.dates]);
      },
      dateType() {
        return this.stepAssets.type;
      },
    },
    created() {
      this.start = this.stepDataModel.getStartDate() ? new Date(this.stepDataModel.getStartDate()) : null;
      this.end = this.stepDataModel.getEndDate() ? new Date(this.stepDataModel.getEndDate()) : null;
      this.CREATION_DATES_TYPES = CREATION_DATES_TYPES;
    },
    mounted() {
      // we hide the loading showed from routing
      this.$_stopGlobalLoading();
    },
    methods: {
      openModal() {
        this.modalOpened = true;
      },
      closeModal() {
        this.modalOpened = false;
      },
      selectAsap() {
        const today = DatesHelpers.getDayjs().startOf("day").toDate();
        this.setDate(today);
        this.save();
      },
      openCalendar(mode) {
        this.calendarMode = mode;
        this.openModal();
      },
      setDate(value) {
        if (value instanceof Date) {
          this.start = value;
          this.end = undefined;
        } else {
          const { start, end } = value;
          this.start = start;
          this.end = end;
        }

        this.closeModal();
      },
      save() {
        this.$emit("saveStep", {
          dates: {
            [ICreationStepDates.startDate]: this.start,
            [ICreationStepDates.endDate]: this.end,
          },
        });
      },
    },
  };
</script>
